import { Pedido } from '@/models/pedido'
import { BaseAPI } from '@/api/base.api'
import { Company } from '@/models/company';
import { AxiosObservable } from 'axios-observable';

export class CompanyAPI extends BaseAPI<Company> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_app/v1/companies`;
  }

  public confirmEmail(body: Company): AxiosObservable<Company> {
    return this.axios.post(`${this.apiUrl}/confirm-email`, body)
  }
}
